module.exports = __webpack_public_path__ + "static/media/diddykong_0.fa89f679.png";